/**
 * Formats the date as a string "Mon DD, YYYY" (i.e. May 1, 2016)
 */
export function displayDate(date: Date, locale: Intl.LocalesArgument): string {
  const dateFormatter = Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
  })

  return dateFormatter.format(date)
}

/**
 * Formats a Date object to a string that resembles the format used in inspection data (YYYY-MM-DD).
 *
 * NOTE: This will throw an error if the supplied date is invalid (`isNaN(date.getTime()) === true`).
 */
export function formatDateLikeInspectionData(date: Date): string {
  if (isNaN(date.getTime())) {
    throw new Error('Invalid date provided to formatDateLikeInspectionData')
  }

  const year = date.getUTCFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0') // Months are zero-indexed
  const day = String(date.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}
